import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Peter Noble
 * id C74BA4DC-A838-471E-AA2D-A5C2D0B74BF3
 * name scan-helper
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/scan-helper.svg
 * tags
 */
export const ScanHelperIcon = createSvgIcon(<><path d="M0 2A2 2 0 0 1 2 0H6V2H2V6H0V2M24 22A2 2 0 0 1 22 24H18V22H22V18H24V22M2 24A2 2 0 0 1 0 22V18H2V22H6V24H2M22 0A2 2 0 0 1 24 2V6H22V2H18V0H22Z" /></>, 'ScanHelperIcon');
export default ScanHelperIcon